import { UserSeasonFighter } from '../../domain/models/userSeason.model';

export interface UserSeasonState {
  seasonId: string | null;
  fighters: UserSeasonFighter[] | null;
  lastUpdated: number | null;
  isLoading: boolean;
  error: string | null;
}

export const initialUserSeasonState: UserSeasonState = {
  seasonId: null,
  fighters: null,
  isLoading: false,
  lastUpdated: null,
  error: null,
};
